<template>
<div>
  <h5 class="is-size-5">
    {{ vulnerability.cvid }}
  </h5>

  <p class="has-text-grey">
    {{ vulnerability.description }}
  </p>

  <div>
    <h5 class="is-size-5">References</h5>
    <p v-for="(reference, index) in vulnerability.references" :key="index">
      <a target="_blank" :href="reference.url">{{ reference.url }}</a>
    </p>
  </div>

  <div v-if="vulnerability.poc">
    <h5 class="is-size-5">Proof of Concept</h5>
  </div>
</div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  
  computed: {
    ...mapGetters('vulnerability', [
      'vulnerability'
    ])
  }

}
</script>